import EditIcon from '@material-ui/icons/Edit';
import ToolbarItem from 'components/Toolbar/ToolbarItem';
const editIcon = React.createElement(EditIcon, null);
// @ts-ignore
const ToolbarEditItem = React.forwardRef((props, ref) => {
    return React.createElement(ToolbarItem, Object.assign({ ref: ref, icon: editIcon, text: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C" }, props));
});
export default React.memo(ToolbarEditItem);
